/**
 * @file TodoTick.ts
 * @brief To-dos' own icon: a tick with a short line after it.
 *
 * @details
 * ⏳ TRIAL (DES 08-10-2026, "todos ka icon banaoo", picked T6 of 8): one
 * large tick and a short dash at its lower right, so a to-do reads as "done,
 * and the next one" rather than lucide's list of ticks (`ListChecks` /
 * `ListTodo`, the icons until today). Drawn on the full 24 grid (ink 2..22
 * across), so it matches the size of the icons beside it.
 *
 * Built with lucide's `createLucideIcon`, like `BoardroomTable` and
 * `AgendaFlag`: same grid, stroke and props as every lucide icon.
 *
 * Revert: put `ListChecks` / `ListTodo` back where `TodoTick` is used.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const TodoTick = createLucideIcon("TodoTick", [
  ["path", { d: "M2 12l5 5L17 7", key: "tick" }],
  ["path", { d: "M17 17h5", key: "line" }],
]);

export default TodoTick;
